import { useState } from "react";
import { HelpCircle, ChevronDown } from "lucide-react";
import { Pill } from "./ui";

const STATI = [
  ["gold", "Piano da preparare", "Il cliente ha fatto il test. Apri la scheda, rivedi i prodotti e premi «Conferma e rendi visibile»: solo allora vede il suo percorso."],
  ["green", "In percorso", "Percorso confermato, tutto regolare. Non devi fare niente."],
  ["blue", "Check da chiedere", "Sono passati 7 giorni o più dalla conferma o dall'ultimo check. Mandagli il messaggio «Check settimanale»: quando lo fa, torna «In percorso»."],
  ["red", "Riordino vicino", "Un prodotto finisce entro 5 giorni (in base alla sua durata dalla conferma). Mandagli il messaggio «Riordino». Ha la precedenza sul check."],
];

export default function StatiGuide() {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-3 rounded-2xl border border-[#26262B] bg-[#141417]" data-testid="stati-guide">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center justify-between gap-2 px-4 py-3 text-sm text-[#9A948A] hover:text-white" data-testid="stati-guide-toggle">
        <span className="flex items-center gap-2"><HelpCircle size={15} className="text-[#E5B13A]" /> Come cambiano gli stati dei clienti</span>
        <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="space-y-3 px-4 pb-4" data-testid="stati-guide-content">
          {STATI.map(([tone, label, txt]) => (
            <div key={label} className="text-sm">
              <Pill tone={tone}>{label}</Pill>
              <p className="mt-1.5 text-[#9A948A] leading-relaxed">{txt}</p>
            </div>
          ))}
          <p className="text-xs text-[#6F6A62]">Lo stato si aggiorna da solo ogni volta che apri o aggiorni l'elenco.</p>
        </div>
      )}
    </div>
  );
}
